const styles = theme => ({
  licenseContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: '35px'
  },
  customUpload: {
    width: '244px',
    height: '120px',
    borderRadius: '2px',
    border: 'dashed 1px rgba(203, 42, 73, 0.3)',
    background: 'rgba(253,230,230,0.5)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  },
  uploadImageText: {
    fontSize: '13px',
    color: '#ea4367',
    marginTop: '10px'
  },
  licenceImage: {
    width: '244px'
    // height: '137px'
  },
  licenseHead: {
    fontSize: '13px',
    color: '#ea4367',
    textAlign: 'left',
    marginBottom: '10px'
  },
  licenseNote: {
    fontSize: '11px',
    fontWeight: '300',
    fontStyle: 'italic',
    color: '#323233'
  },
  changeLiceneceButton: {
    width: '120px',
    minHeight: '25px',
    opacity: '0.95',
    borderRadius: '17.5px',
    background: '#1f2532 !important',
    fontSize: '11px',
    color: '#ffffff',
    position: 'absolute',
    left: '64px',
    bottom: '8px'
  },
  licenceText: {
    marginLeft: '25px',
    marginTop: '3px'
  },
  profileSubHeadingInstructions: {
    fontSize: "12px",
    marginBottom: "10px",
    color: "rgba(0,0,0,0.38)"
  }
})

export default styles
